import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { Blobs } from 'my-lib-sanfelici';







@Component({
  selector: 'app-marchi-list-blobs',
  templateUrl: './marchi-list-blobs.component.html',
  styleUrls: ['./marchi-list-blobs.component.scss']
})
export class MarchiListBlobsComponent implements OnInit {
blobs: Observable<Blobs[]>;
  constructor(private db: AngularFirestore) { }

  ngOnInit() {
    this.blobs= this.db.
    collectionGroup<Blobs>('blobs', ref => ref.where('type', '==', 'marchi'))
.valueChanges();
  }

}
